<template>
  <!-- <div class="content">
    <div class="text">
      <p class="title" id="title">{{ title }}</p>
      <p
        class="desc"
        v-for="(item, index) in desc"
        :key="index"
      >
        {{ item.text }}
      </p>
      <div class="btn">
        <img src="@/assets/images/gp.png" class="btn" @click.stop="gpAction(false)"/>
        <img src="@/assets/images/ios.png" class="btn ios" @click.stop="gpAction(true)" alt="">
      </div>
    </div>
    <img src="@/assets/images/screen.png" class="phone" />
  </div> -->
  <div class="main home">
    <Header></Header>
    <div class="mseciton">
      <div class="page1">
        <div class="left">
          <h1>Emotional Support, Work & Study</h1>
          <div class="desc">Are you still bothered by various problems in work, study, and life? Now, with Wing Chat APP, everything will become simple. Wing Chat can not only provide you with efficient tools but also become your emotional support.</div>
          <div class="desc">You can have in-depth conversations with AI, share your joys and sorrows, and let it become your most trusted friend. Whether it's work, study, or life, Wing Chat will be your indispensable assistant.</div>
          <div class="btn" @click.stop="gpAction(false)">
            <svg t="1739542193943" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2352"><path d="M932.169143 529.92c0-35.291429-2.852571-61.019429-9.051429-87.698286H520.374857v159.177143h236.397714c-4.754286 39.570286-30.500571 99.145143-87.698285 139.172572l-0.804572 5.321142 127.341715 98.651429 8.832 0.877714c81.005714-74.825143 127.725714-184.923429 127.725714-315.52" p-id="2353"></path><path d="M520.374857 949.321143c115.821714 0 213.046857-38.125714 284.068572-103.899429L669.074286 740.571429c-36.205714 25.252571-84.845714 42.898286-148.699429 42.898285-113.426286 0-209.700571-74.825143-244.022857-178.249143l-5.028571 0.420572-132.406858 102.473143-1.737142 4.809143c70.546286 140.123429 215.424 236.397714 383.195428 236.397714" p-id="2354"></path><path d="M276.352 605.220571a264.082286 264.082286 0 0 1-14.299429-84.845714c0-29.549714 5.248-58.148571 13.824-84.845714l-0.237714-5.668572-134.070857-104.118857-4.388571 2.084572A429.348571 429.348571 0 0 0 91.428571 520.374857c0 69.12 16.676571 134.4 45.750858 192.548572l139.172571-107.702858" p-id="2355"></path><path d="M520.374857 257.28c80.548571 0 134.875429 34.797714 165.851429 63.872L807.314286 202.971429C732.946286 133.851429 636.196571 91.428571 520.411429 91.428571c-167.789714 0-312.685714 96.274286-383.213715 236.397715l138.697143 107.702857c34.797714-103.405714 131.072-178.249143 244.498286-178.249143" p-id="2356"></path></svg>
            Google Play
          </div>
          <!-- <img src="@/assets/images/gp.png" class="btn" @click.stop="gpAction(false)"/> -->
        </div>
        <div class="right">
          <div class="app-counter">
            <div class="appc-item">
              <svg t="1739543590240" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3550"><path d="M394.5 312.2C418.7 164.8 467.2 63.9 512 63.9s93.3 100.9 117.5 248.3h-235zM391 79.3c-121.6 34.8-222 120.5-277.3 232.9h205.2C333.3 217.4 358 136.4 391 79.3z m314.1 232.9h205.2C855.1 199.8 754.6 114.1 633 79.3c33 57.1 57.7 138.1 72.1 232.9zM318.9 711.8H113.7C168.9 824.2 269.4 910 391 944.6c-33-57-57.7-138-72.1-232.8z m591.4 0C855.1 824.2 754.6 910 633 944.6c32.9-57.1 57.7-138 72.1-232.9h205.2v0.1zM512 960.1c44.8 0 93.3-100.9 117.5-248.3h-235c24.2 147.4 72.7 248.3 117.5 248.3z" fill="#ffffff" fill-opacity=".7" p-id="3551"></path><path d="M867 499.2c-8 0-14.8 2.5-20.5 7.6-5.7 5.1-9.5 12.2-11.4 21.3h60.2c-0.8-9.4-3.8-16.5-8.9-21.5-5.1-4.9-11.6-7.4-19.4-7.4zM213.3 451.4c-8.7-5.9-18.7-8.9-30-8.9s-21.3 3-30 8.9-15.4 14.3-20.2 25.1c-4.8 10.8-7.2 23.3-7.2 37.6 0 14.2 2.4 26.8 7.2 37.7 4.8 10.9 11.5 19.3 20.2 25.3 8.7 5.9 18.7 8.9 30 8.9s21.3-3 30-8.9 15.4-14.4 20.2-25.3c4.8-10.9 7.2-23.5 7.2-37.7 0-14.2-2.4-26.7-7.2-37.6-4.8-10.7-11.5-19.1-20.2-25.1z" fill="#ffffff" p-id="3552"></path><path d="M915.3 362.6H108.7c-24.7 0-44.8 20.1-44.8 44.8v209.1c0 24.8 20.1 44.8 44.8 44.8h806.6c24.8 0 44.8-20.1 44.8-44.8V407.4c0-24.7-20.1-44.8-44.8-44.8zM272.1 573.2c-9.1 16.8-21.3 29.6-36.8 38.4-15.5 8.9-32.8 13.3-51.9 13.3s-36.4-4.4-51.9-13.3-27.7-21.7-36.7-38.4c-9-16.8-13.4-36.4-13.4-59.1 0-22.4 4.5-42 13.4-58.8 9-16.8 21.2-29.6 36.7-38.4 15.5-8.9 32.8-13.3 51.9-13.3s36.4 4.4 51.9 13.3 27.8 21.7 36.8 38.4c9.1 16.8 13.6 36.3 13.6 58.8 0 22.7-4.6 42.3-13.6 59.1z m187 48.2h-40.6V544c0-27.7-9.2-41.5-27.5-41.5-9.7 0-17.6 3.8-23.5 11.3-5.9 7.5-8.9 18.1-8.9 31.7v76H318V470h35.7c1 11.9 1.8 20 2.6 24.3 9.7-18.7 25.9-28.1 48.5-28.1 16.8 0 30 5.5 39.8 16.5 9.7 11 14.6 27 14.6 48.1v90.6z m69 0h-40.6V399h40.6v222.4z m73.4 0h-40.6V470h40.6v151.4zM598 443.3c-4.9 5-10.6 7.5-17.2 7.5-6.4 0-12-2.5-16.8-7.5-4.8-5-7.2-10.8-7.2-17.4 0-6.8 2.3-12.7 7-17.5 4.7-4.9 10.3-7.3 17-7.3 6.6 0 12.4 2.5 17.2 7.5 4.9 5 7.3 10.8 7.3 17.4 0 6.5-2.5 12.3-7.3 17.3z m172.4 178.1h-40.6V544c0-27.7-9.2-41.5-27.5-41.5-9.7 0-17.6 3.8-23.5 11.3-5.9 7.5-8.9 18.1-8.9 31.7v76h-40.6V470H665c1 11.9 1.9 20 2.6 24.3 9.7-18.7 25.9-28.1 48.5-28.1 16.8 0 30 5.5 39.8 16.5 9.7 11 14.6 27 14.6 48.1v90.6z m164.7-64.9H834.6c1.8 11.3 5.8 19.8 12.3 25.6 6.4 5.8 14.4 8.6 24 8.6 6.8 0 12.9-1.5 18.3-4.5s9.5-7.6 12.4-13.6l29.8 17.5c-4.1 11.1-11.9 19.7-23.5 25.7s-24.5 9.1-38.7 9.1c-13.6 0-26.3-3-38-9.1-11.7-6-21.1-15.1-28.2-27.2-7.1-12.1-10.7-26.6-10.7-43.6 0-16.8 3.6-31.1 10.7-43 7.1-11.9 16.4-20.9 27.9-26.9s24-9.1 37.4-9.1c13.4 0 25.4 3 35.8 8.9 10.4 5.9 18.5 14.3 24.3 25.1 5.7 10.8 8.6 23.2 8.6 37.3-0.1 6.5-0.7 12.8-1.9 19.2z" fill="#ffffff" p-id="3553"></path></svg>
              <div class="title">Always Online</div>
            </div>
            <div class="appc-item">
              <svg t="1739544478114" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2521"><path d="M838.987081 1024c-8.267117-2.180507-16.924741-3.434835-24.714457-6.741886-15.514005-6.587523-31.309136-8.071863-47.728874-5.607164-0.785105 0.117561-1.624391 0.450822-2.351226 0.290325-31.097525-6.839002-60.090192 3.974595-89.656353 10.375042-5.46609 1.182769-11.407537 0.167653-20.921826 0.167653 14.295457-15.946427 26.331691-29.371929 40.746754-45.454318-12.995126-13.472527-25.645747-27.926436-39.716303-40.835692-16.777534-15.39031-17.278447-14.760591-37.961062-4.06251-44.450447 22.986816-92.578007 29.947469-141.712506 31.483944-46.839497 1.464916-92.517693-5.630676-136.380333-22.483858-6.929984-2.661997-11.577234-1.321798-15.357598 3.91837-9.051199 12.532037-21.637417 13.847701-35.817357 13.687205-22.988861-0.25659-45.997145 1.056007-69.000317 1.642792-2.949256 0.074626-5.908734-0.233078-10.92298-0.453889 9.495888-11.334956 24.290214-17.336717 21.014853-33.600048-13.997975 4.272076-30.294019 18.713718-50.005475 44.602765 3.832499 9.254632 7.726334 18.659537 12.896988 31.142505-27.77514-7.328671-52.680762-17.139418-78.321397-19.753369-25.477072-2.598616-51.691202 2.043522-81.423993 3.727205 8.194535-10.010091 13.511374-19.553003 21.477942-25.621212 17.697579-13.477639 25.088608-32.954994 34.347329-51.672801 10.545762-21.315401 19.513135-43.972023 33.435462-62.907574 15.625433-21.255087 35.983987-39.036492 54.359333-58.25828 7.100704-7.423742 14.405862-14.65223 23.065531-23.438661-18.346722-5.865799-35.819401-11.45354-57.397526-18.352856 19.057201-11.374825 35.294975-21.069033 52.184959-31.15375-4.478575-2.85214-8.927505-5.685879-15.131675-9.636962 8.746562-3.66178 15.665302-7.034256 22.905034-9.460108 7.673176-2.571015 9.796436-7.34196 7.640464-14.665519-4.020597-13.64018-8.064707-27.274227-12.836674-43.397506 14.205497 7.04959 26.895986 13.349855 39.581363 19.64603 10.827909-34.192966-1.245128-50.514566-35.367557-62.090779-53.987226-18.322188-109.486392-32.162733-164.169785-48.495578-12.293847-3.672002-23.850636-9.804614-35.747842-14.807615 0.03169-1.51603 0.063381-3.037171 0.094049-4.554223 19.044934-3.184378 38.09089-6.367735 59.09961-9.881285-13.898815-12.811117-27.508327-25.358488-43.922954-40.49323 8.694426-1.051918 14.282167-2.715155 19.671587-2.229576 54.738596 4.950865 108.19424 16.115101 160.146121 33.718632-2.256155-13.854857-6.634548-17.506414-19.676698-21.822448-14.210608-4.699386-28.006174-10.82382-41.559461-17.220178-3.911214-1.843157-6.980076-6.394314-9.382416-10.344374-6.360579-10.456824-12.31736-21.174327-18.046174-31.994058-1.527275-2.888942-3.222202-8.559486-2.121215-9.403883 2.74889-2.110992 7.237688-3.338742 10.715459-2.823516 6.155102 0.914934 12.080192 3.384744 20.775641 6.008917 2.160061-14.905753 5.391464-29.433266 6.001761-44.070161 0.432421-10.347441-8.25076-14.126782-18.319121-10.830976-14.619517 4.786279-29.29117 9.823015-44.336975 12.6772-5.373064 1.017161-14.680853-2.246955-17.418499-6.575256-13.693338-21.667063-27.468458-43.617295-37.593044-67.031421-3.654624-8.450103 0.372107-22.469546 5.070471-31.858096 13.449015-26.86634 28.746299-52.834102 43.913754-78.806976 7.540281-12.912322 21.196817-17.525837 34.603919-21.343002 21.336869-6.070253 42.880236-11.419805 65.040034-17.260047-20.958628-47.110399-39.559896-95.206269-36.42152-149.097401 38.803414 39.611009 64.332622 87.606697 90.319808 135.864086 45.124124-47.435482 90.608088-94.352672 146.231972-129.465683 1.473094 0.905733 2.945167 1.810444 4.416217 2.716178-2.253088 7.159996-3.528884 14.827038-6.918739 21.404339-25.398357 49.27455-54.443159 95.969907-96.957422 132.782957-0.851553 0.737058-1.414825 1.812489-0.789194 0.990582 18.454061 19.057201 37.456059 36.975591 54.459515 56.624688 26.892919 31.080147 35.416626 66.686915 25.970829 107.639146-7.282668 31.560615-10.722615 64.020829-15.514005 96.134493-0.903689 6.060031-0.129829 12.370518-0.129829 19.911821 10.554962-12.020901 20.156144-22.956148 29.758348-33.889351 1.399491 0.612341 2.797959 1.224682 4.19745 1.837023 0 5.229945 0.777949 10.600964-0.127784 15.670413-5.296393 29.636698-11.91254 59.073031-16.019008 88.862047-1.359622 9.857772 4.042065 20.488383 5.223812 30.894093 2.817383 24.737969 25.924827 27.510371 41.536971 38.022398 1.505807 1.015116 13.041128-7.024033 13.846679-11.870627 2.766269-16.605792 4.656451-33.326079-1.34531-50.402116-8.502239-24.18083-14.741167-49.156989-22.521682-75.76776 18.237339 1.117344 25.804199 16.59148 40.004584 23.155491 0.362907-7.725312 1.934139-14.892464 0.782038-21.588348-3.718005-21.632305-7.426809-42.696227-20.64479-62.074422-13.618712-19.963957-22.772139-43.090825-32.861967-65.297647-5.522315-12.147662-3.911214-24.762503 2.828628-36.594284 20.759285-36.441965 45.096523-70.496924 76.436327-98.212772 10.997606-9.727944 28.215739-13.652447 43.305502-17.16702 14.485599-3.373499 29.892266-2.781603 45.25702-3.960283C531.760502 116.543138 526.608249 59.595412 534.109683 1.877914c1.284996-0.625631 2.569993-1.252284 3.852945-1.877914 3.364298 3.264116 8.090263 5.916912 9.867995 9.890485 12.25909 27.413256 24.82384 54.749841 35.414581 82.820417 7.077192 18.756653 11.05792 38.679719 16.467785 58.237834 52.05922-41.448033 105.848125-78.635234 173.195428-90.842189-34.266569 61.345542-79.460208 110.734587-146.06023 138.310383 30.064008 32.218958 47.403792 69.86516 58.773505 110.946197 10.192055 36.833495 1.738885 69.06881-21.444207 98.091122-6.88296 8.616734-15.064205 16.354313-23.431505 23.593024C619.328352 449.582094 612.905415 476.155042 600.099409 501.754786c15.681658-5.168609 29.026401-9.566425 42.370122-13.96424 0.945602 1.589634 1.893248 3.180289 2.836806 4.769923-18.081953 27.425523-42.622624 49.276595-64.818201 73.74775 18.762787-13.464349 37.742296-26.637351 56.233158-40.463585 24.167541-18.072753 47.738075-36.940834 72.024199-54.845934 6.883982-5.073538 14.96709-9.450908 23.170825-11.652883 83.105631-22.326428 166.331891-44.197945 249.581663-65.990748 7.86843-2.058857 16.103856-2.709022 24.170608-4.014464 0.60723 1.108143 1.21446 2.216286 1.819645 3.322385-10.596875 10.150142-21.190684 20.299262-33.877084 32.449992 18.339566-1.554876 33.946598-2.881786 49.556697-4.206651 0.583718 1.425048 1.16948 2.85214 1.753197 4.276165-7.773359 6.135679-15.485382 12.344961-23.321099 18.393747-60.161751 46.428544-129.375723 73.229458-201.813942 93.050297-34.046781 9.312901-67.9576 19.150228-102.121942 27.98675-20.915692 5.406799-36.634152 18.304809-51.76685 32.491905-4.558312 4.274121-8.909104 8.76803-14.610317 14.40484 7.663976 1.086676 13.972419 1.981164 22.80383 3.233447-5.272881 7.134439-9.484643 12.834629-14.403818 19.490645 4.93042 1.024317 9.237253 1.918805 14.351682 2.981968-0.78715 5.152253-1.478206 9.679897-2.209131 14.453909 17.272314 2.005698 34.226701 3.973573 51.183133 5.942469 0.466156 1.410736 0.934357 2.819427 1.399491 4.229141-11.227617 10.68888-22.461368 21.382871-34.009979 32.376388 12.750803 20.621278 25.063051 39.825687 44.362531 55.321291 37.979463 30.490295 73.458447 64.085232 110.142691 96.198896 14.987535 13.120866 17.613753 32.301762 21.395138 49.372688 4.686096 21.183528 15.05705 29.964847 35.510675 30.566966 6.05083 0.178898 12.033168 2.788759 21.488165 5.136919-9.562336 4.275143-16.035364 7.166129-24.332127 10.874933 4.93962 2.048634 7.933856 3.291717 10.927069 4.532756 0.111428 0.984448 0.223878 1.967874 0.332239 2.952323-24.99047 5.813663-49.989118 11.628348-77.077291 17.932702 9.978401 18.481662 19.378195 35.902205 28.783101 53.325815C840.950866 1021.621172 839.968462 1022.811097 838.987081 1024z" p-id="2522" fill="#ffffff"></path></svg>
              <div class="title">Role play</div>
            </div>
            <div class="appc-item">
              <svg t="1739543704223" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6835"><path d="M516.6592 56.32c102.2976 0 196.64896 39.7056 267.0592 112.34304l2.41664 2.51392c68.59264 71.3216 107.59168 168.56576 109.98272 273.5872l0.07168 3.75808v12.52352H796.8768v-11.66848c-1.91488-163.24096-116.6336-287.6416-268.85632-293.57056l-4.62848-0.14336-6.7328-0.13312h-4.26496a269.38368 269.38368 0 0 0-197.5296 86.76352l-4.48 4.9152a295.30624 295.30624 0 0 0-76.11904 201.63072l0.08704 4.24448 0.08704 1.1264 0.2048 1.90464 0.18432 2.3552c0.10752 1.41824 0.16896 2.57024 0.2048 3.68128l0.02048 1.664-0.01024 1.99168c-0.22016 18.92864-3.67104 29.57312-13.48608 39.81312l-1.54624 1.58208c-3.4048 3.61472-12.69248 14.67904-27.65824 32.94208l-11.15648 13.6448-31.82592 39.25504a13.00992 13.00992 0 0 0-2.3552 11.9296c1.14176 3.80416 3.94752 6.85568 7.30624 8.2432l0.84992 0.3072 1.9456 0.46592 25.0368 4.3776c8.576 1.46432 15.73376 2.64704 21.44768 3.5328l4.00896 0.60416 4.11648 0.58368 0.75776 0.01536c7.36768 0.384 13.66528 4.20864 19.14368 10.90048l0.95744 1.21344 0.89088 1.19296c2.42176 3.71712 4.09088 7.86944 4.90496 12.06272l0.62976 3.70176c0.3584 2.28352 0.59392 4.58752 0.7168 6.7072l0.05632 1.56672v1.51552l10.10176 203.98592 24.48384-3.85536c39.12704-6.0416 78.28992-11.8784 117.4784-17.536l15.45216-2.23232 45.1072-6.41536v102.36928l-22.97344 3.71712a4499.01056 4499.01056 0 0 1-165.41184 23.18336l-20.736 2.4576-0.66048 0.04096c-46.11072-0.47104-84.3264-35.7376-88.76544-81.72544l-0.1536-1.75104-0.19456-4.4032-8.09472-169.47712-18.8928-3.92192-4.78208-1.1008c-61.2864-14.45888-88.9088-38.4512-90.9056-84.0704l-0.07168-1.7664-0.03584-1.7664c-0.33792-17.5104 7.4752-36.21888 23.14752-57.09312l28.56448-37.68832 43.776-57.69216 10.25536-13.2864v-4.59776c1.34144-209.65376 148.5312-376.51456 341.9648-390.1696l5.87776-0.36864 6.02112-0.2816L497.38752 56.32h19.27168zM972.8 504.61696v404.18816h-99.96288V504.61696H972.8z m-248.1664 3.95776l135.45472 399.90784h-102.05184l-25.97376-88.59136h-110.40256l-25.97376 88.59136H494.58176l134.89664-399.90784h95.15008z m-48.09728 127.7952l-25.50784 91.89888h51.5584l-26.05056-91.89888z" fill="#ffffff" p-id="6836"></path></svg>
              <div class="title">Exclusive AI</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page2">
      <h1>Awesome Screenshort</h1>
      <div class="desc">Come download the Wing Chat APP and let it become an indispensable assistant in your work, study, and life, accompanying you through every moment!</div>
      <div class="imgs">
        <img src="/static/img/1.webp" alt="">
        <img src="/static/img/2.webp" class="m2">
        <img src="/static/img/3.webp" alt="">
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"

export default {
  components: {Header, Footer},
  data() {
    return {
      title: "",
      desc: [],
      screen: "",
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      console.log(config);
      // this.screen = `${config.baseUrl}images/screen.png?v=${new Date().getTime()}`;
      this.screen = `${config.screen}`;
      const { title, desc } = config.page[0];
      this.title = title;
      this.desc = desc;
    },
    gpAction(isIos = false){
      // window.gtagEvent('10001')
      // alert('Coming soon')
      // if (isIos) {
      //   window.open('https://apps.apple.com/us/app/id6503810311');
      // } else {
      //   window.open('https://play.google.com/store/apps/details?id=ai.character.talkie.waifu');
      // }
      window.open('https://play.google.com/store/apps/details?id=com.spicy.chat.lover.app');
    }
  },
};
</script>

<style lang="less">
.main{
  .mseciton{
    position: relative;
    width: 100%;
    padding: 80px 0;
  }
  .header{
    background-color: #000;
  }
  header{
    background-color: transparent;
    color: #fff;
    position: relative;
    max-width: 1140px;
    justify-content: space-between;
    .logo{
      span{
        font-family: 'Poppins', sans-serif;
        color: #fff;
        transition: all .3s ease;
        font-weight: 500;
        font-size: 20px;
        line-height: 70px;
        &:hover{
          color: #ddd;
          text-decoration: none;
        }
      }
      text-decoration: none;
      &:hover{
        color: #ddd;
        text-decoration: none;
      }
    }
    .nav{
      a{
        color: #fff;
        font-weight: 400;
        transition: all 500ms ease;
        text-transform: capitalize;
        font-family: 'Poppins', sans-serif;
        text-decoration: none;
        &:hover{
          color: #ddd;
          text-decoration: none;
        }
        &.active{
          // color: #918bca;
          text-decoration: underline;
          &::after{
            display: none;
          }
        }
      }
    }
  }  
}
.mseciton{
  overflow: hidden;
  background-color: #fafafa;
}
.page1{
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  color: #000;
  font-family: 'Poppins',sans-serif;
  flex-direction: row;
  max-width: 1000px;
  line-height: 28px;
  .left, .right{
    width: 50%;
  }
  .left{
    padding-right: 30px;
  }
  .desc, h1{
    text-align: left;
  }
  h1{
    line-height: 36px;
  }
  .desc{
    margin-bottom: 20px;
  }
  .btn{
    user-select: none;
    border-radius: 40px;
    cursor: pointer;
    transition: transform .4s ease-out 0s;
    margin-top: 10px;
    // padding: 0 30px;
    height: 46px;
    display: inline-flex;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    border: 2px solid #0e0e52;
    color: #0e0e52;
    padding: 0 24px;
    svg{
      fill: #0e0e52;
      width: 32px;
      margin-right: 5px;
    }
    &:hover{
      transform: scale(1.1);
      background-color: #00e793;
      border-color: #00e793;
      color: #fff;
      svg{
        fill: #fff
      }
    }
  }
}
.app-counter{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .appc-item{
    width: 32%;
    text-align: center;
    color: #fff;
    box-shadow: 1px 2px 11px 0px rgba(148, 148, 148, 0.18);
    background: linear-gradient(10deg, #48249d 0%, #0e0e52 100%);
    height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    svg{
      height: 60px;
      width: 60px;
      margin-bottom: 10px;
    }
  }
}
.page2{
  padding: 80px 0 60px 0;
  font-family: 'Poppins',sans-serif;
  color: #2e2e2e;
  display: flex;
  flex-direction: column;
  align-items: center;
  h1{
    margin-top: 0;
    text-align: center;
    max-width: 820px;
    margin: 0 auto;
    color: #444;
  }
  .desc{
    font-size: 16px;
    line-height: 32px;
    color: #777;
    text-align: center;
    max-width: 900px;
    margin: 0 auto;
    margin-top: 12px;
  }
  .imgs{
    max-width: 900px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 900px;
    margin-top: 60px;
    img{
      width: 240px;
      border-radius: 10px;
      // &.m2{
      //   position: relative;
      //   top: -30px;
      // }
    }
  }
}

.content {
  padding: 6px 0 28px;
  flex: 1;
  // background-image: url( "~@/assets/images/bg.png" );
  background-color: #2e2e2e;
  background-size: cover;
  width: 100%;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  .phone {
    width: 233px;
    border-radius: 3px;
  }
  .text {
    margin-right: 56px;
    max-width: 540px;
    //margin-top: 80px;
    img{
      width: 140px;
      margin-top: 12px;
    }
  }
  .title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    // line-height: 38px;
    margin-bottom: 20px;
  }
  .desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    margin-bottom: 18px;
  }
  .btn{
    cursor: pointer;
    &.ios{
      height: 36px;
      width: auto;
      margin-left: 30px;
    }
  }
}
</style>
